<script>
    export default {
        props: {
            prompt: Object,
        },
        methods: {
            async openObject() {
                this.$store.commit('PROMPT_DATA_EDIT_SET', this.prompt);
                this.$store.commit('IS_SHOW_PROMPT_EDIT', true);
                await this.$store.dispatch('CHECK_PROMPT_EDIT');
            }
        }
    }
</script>


<template>
    <li @click="openObject">
        <div class="blur_white cursor_pointer_label">
            <label>[{{ prompt['id'] }}]</label>
            <label
                class="ml_5"
            >{{ prompt['name'] }}</label>
        </div>
    </li>
</template>